import { Loader } from 'modules/Loader';
import { StateComponent } from './StateComponent';
export function DialogLoading(props) {
    return <StateComponent icon={<Loader size={24}/>} {...props}/>;
}
